import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InputBox from '../InputBox/InputBox';
import isValidName from '../../utils/isValidName/isValidName';

const TextInput = ({ value, onError, errorMessage, icon, hasError, required, ...props }) => {
  const validate = useCallback(() => {
    if (!isValidName(value, required)) {
      if (onError) onError(errorMessage);
    }
  }, [onError, errorMessage, value, required]);

  return (
    <InputBox
      {...props}
      value={value}
      errorMessage={hasError ? errorMessage : null}
      icon={icon || 'user'}
      onBlur={validate}
      required={required}
    />
  );
};

export const FirstNameInput = props => (
  <TextInput
    {...props}
    errorMessage="Invalid first name.  Please correct this field"
    name="firstName"
    label="First Name"
    placeholder="Your first name"
  />
);

export const LastNameInput = props => (
  <TextInput
    {...props}
    errorMessage="Invalid last name.  Please correct this field"
    name="lastName"
    label="Last Name"
    placeholder="Your last name"
  />
);

export const OrgInput = props => (
  <TextInput
    {...props}
    errorMessage="Invalid org/company name.  Please correct this field"
    name="org"
    label="Org/Company Name"
    placeholder="Your org/company name"
    icon="users"
  />
);

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

TextInput.propTypes = {
  ...propTypes,
  errorMessage: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
};
LastNameInput.propTypes = propTypes;
LastNameInput.displayName = 'lastName';
FirstNameInput.propTypes = propTypes;
LastNameInput.displayName = 'firstName';
OrgInput.prototypes = propTypes;
OrgInput.displayName = 'org';

export default TextInput;
